import React, { useEffect } from 'react'
import { ToastStack, toast } from '@vtex/shoreline'

const FEEDBACK_TOAST_EVENT = 'feedback:toast'

window.feedbackToastInitialized = false

interface PayloadInterface {
  type: keyof typeof toast
  message: JSX.Element | string
}

export const dispatchFeedbackToast = (() => {
  let pendingEventList = [] as PayloadInterface[]

  const createCustomEvent = (payload: PayloadInterface) => {
    const event = new CustomEvent(FEEDBACK_TOAST_EVENT, {
      detail: payload,
      bubbles: true,
      cancelable: true
    })
    document.dispatchEvent(event)
  }

  const feedbackToastInitializedHandler = setInterval(() => {
    if (window.feedbackToastInitialized) {
      pendingEventList.forEach(payload => createCustomEvent(payload))
      pendingEventList = []
      clearInterval(feedbackToastInitializedHandler)
    }
  }, 500)

  return (payload: PayloadInterface) => {
    if (!window.feedbackToastInitialized) {
      pendingEventList.push(payload)
      return
    }

    createCustomEvent(payload)
  }
})()

interface FeedbackProviderProps {
  children: React.ReactNode
}

export const FeedbackContext = React.createContext(
  {} as { toast: typeof toast }
)

const Feedback = ({ children }: FeedbackProviderProps) => {
  useEffect(() => {
    const handleFeedbackEvent = (event: CustomEvent<PayloadInterface>) => {
      const { type, message } = event?.detail || {}
      return toast?.[type]?.(message)
    }

    document.addEventListener(FEEDBACK_TOAST_EVENT, handleFeedbackEvent)
    window.feedbackToastInitialized = true

    return () =>
      document.removeEventListener(FEEDBACK_TOAST_EVENT, handleFeedbackEvent)
  }, [])

  return (
    <FeedbackContext.Provider value={{ toast }}>
      <ToastStack
        position="top-right"
        toastOptions={{
          duration: 5000,
          className: 'feedback'
        }}
      />
      {children}
    </FeedbackContext.Provider>
  )
}

export default Feedback
